import Form from '@atlas/uicorn/lib/Control/Form';
import FormItem from '@atlas/uicorn/lib/Control/FormItem';
import Input from '@atlas/uicorn/lib/Input/Input';
import type { TExample } from '@atlas/uicorn/preview/modules';
import React from 'react';
import styled from 'styled-components';

const FormItemRow = React.memo(function FormItemRow(props: TFormItemRowProps): React.ReactElement {
    return <SFormItemRow {...props} />;
});

export default FormItemRow;

// #region Styles

export const SFormItemRow = styled.div`
    display: flex;
    gap: var(--form-gap);

    & > * {
        flex: 1;
        flex-shrink: 0;
    }
`;

// #endregion

// #region Types

export type TFormItemRowProps = React.HTMLAttributes<HTMLDivElement>;

// #endregion

// #region Examples

export const Example: TExample = {
    render() {
        return (
            <Form layout="vertical">
                <FormItem label="Input 1" children={<Input />} />
                <FormItemRow>
                    <FormItem label="Input 2" children={<Input />} />
                    <FormItem label="Input 3" children={<Input />} />
                </FormItemRow>
                <FormItem label="Input 4" children={<Input />} />
                <FormItem label="Input 5" children={<Input />} />
            </Form>
        );
    },
    controls: {
        message: { type: 'string', initial: 'Hello, World!' },
    },
    handlers: {
        onClick: 'console',
    },
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('FormItemRow', async () => {
        const testModule = '@test';
        const { render } = await import(/* @vite-ignore */ testModule);

        it('matches snapshot', () => {
            const result = render(<Example.render />);
            expect(result.container).toMatchSnapshot();
        });
    });
}

// #endregion
